import { Box, Chip, Stack, Typography } from "@mui/material";
import { OssStatusChip } from "../OssStatusChip";
import { riskLevel } from "../../constants/labels";
import { getOrderItemSummaryText, getOrderQuantitySummaryText } from "../../utils/orderStatusSummaryUtils";

const MobileSummary = ({ summary }) => {
  const entries = summary?.entries || [];
  return (
    <Stack direction="row" spacing={0.45} flexWrap="wrap" useFlexGap sx={{ mt: 1 }}>
      <Chip size="small" label={`품목 ${summary?.lineCount || 1}`} variant="outlined" sx={{ height: 22, borderRadius: "999px", fontSize: 11.5, fontWeight: 800 }} />
      {entries.length ? entries.slice(0, 2).map((entry) => (
        <Chip
          key={entry.key}
          size="small"
          label={entry.label}
          variant="outlined"
          sx={{
            height: 22,
            borderRadius: "999px",
            borderColor: `${entry.tone}55`,
            bgcolor: entry.bg,
            color: entry.tone,
            fontSize: 11.5,
            fontWeight: 800,
          }}
        />
      )) : (
        <Chip size="small" label="모두 정상" variant="outlined" sx={{ height: 22, borderRadius: "999px", borderColor: "#14b8a655", bgcolor: "#ecfeff", color: "#0f766e", fontSize: 11.5, fontWeight: 800 }} />
      )}
    </Stack>
  );
};

export const OssOrderMobileCard = ({ row, summary, onOpen }) => {
  const riskMeta = riskLevel[row.risk_level] || riskLevel.NORMAL;

  return (
    <Box
      onClick={onOpen}
      sx={{
        p: 1.4,
        border: "1px solid #e5e7eb",
        borderLeft: `4px solid ${riskMeta.tone}`,
        borderRadius: "8px",
        bgcolor: "#fff",
        cursor: "pointer",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 1 }}>
        <Box sx={{ minWidth: 0 }}>
          <Typography noWrap sx={{ fontSize: 14, fontWeight: 800, color: "#111827" }}>
            {row.order_no}
          </Typography>
          <Typography noWrap sx={{ mt: 0.25, fontSize: 12.5, color: "#6b7280" }}>
            {row.customer_name} · {row.site_name || "사업장 미등록"}
          </Typography>
        </Box>
        <OssStatusChip type="risk" value={row.risk_level} />
      </Box>
      <MobileSummary summary={summary} />
      <Typography sx={{ mt: 1.1, fontSize: 14, fontWeight: 700, color: "#111827" }}>
        {getOrderItemSummaryText(row)}
      </Typography>
      <Typography sx={{ mt: 0.25, fontSize: 12, color: "#6b7280" }}>
        {row.item_code_snapshot} · {row.specification_snapshot || "규격 미등록"}
      </Typography>
      <Box
        sx={{
          mt: 1.2,
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 0.8,
          fontSize: 12.5,
          color: "#4b5563",
        }}
      >
        <Box>요청 납기 <strong>{row.requested_due_date}</strong></Box>
        <Box>착수일 <strong>{row.required_start_date || "-"}</strong></Box>
        <Box>수량 <strong>{getOrderQuantitySummaryText(row)}</strong></Box>
        <Box>여유일 <strong>{row.available_margin_days ?? "-"}</strong></Box>
      </Box>
      <Box sx={{ mt: 1.15 }}>
        <OssStatusChip value={row.schedule_status} />
      </Box>
    </Box>
  );
};
